import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Skyteplott from './pages/Skyteplott';
import { BiathlonEventProvider } from './contexts/BiathlonEventContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Innskytingsskive from './pages/Innskytingsskive';
import Innskytingsliste from './pages/Innskytingsliste';
import FordeleSkiver from './pages/FordeleSkiver';
import Stafettuttak from './pages/Stafettuttak';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <BiathlonEventProvider>
          <div className="App">
            <Navigation />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/skyteplott" element={<Skyteplott />} />
              <Route path="/innskytingsskive" element={<Innskytingsskive />} />
              <Route 
                path="/innskytingsliste" 
                element={
                  <ProtectedRoute>
                    <Innskytingsliste />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/fordele-skiver" 
                element={
                  <ProtectedRoute>
                    <FordeleSkiver />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/stafettuttak" 
                element={
                  <ProtectedRoute>
                    <Stafettuttak />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </BiathlonEventProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
